import { render, staticRenderFns } from "./SocialSharingWidget.vue?vue&type=template&id=2e4d92fd&scoped=true&"
import script from "./SocialSharingWidget.vue?vue&type=script&lang=js&"
export * from "./SocialSharingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4d92fd",
  null
  
)

export default component.exports